import { IMockLoginJWT } from "@/utils/types/string-helper"
import { ValueOf } from "@/utils/types-utils"

type MockDataRecord = Record<keyof IMockLoginJWT, ValueOf<IMockLoginJWT>>

class MockData {
  key = "shine_mock_data_20220809"

  /**
   * 判断值是否存在
   */
  exist() {
    return localStorage.getItem(this.key) !== null
  }

  get() {
    const item = localStorage.getItem(this.key) || ""

    return JSON.parse(item) as IMockLoginJWT
  }

  set(data: MockDataRecord) {
    localStorage.setItem(this.key, JSON.stringify(data))
  }

  clear() {
    localStorage.removeItem(this.key)
  }
}

export default new MockData()
